module.exports = __webpack_public_path__ + "img/delete.35b0a5ba.svg";